{
  "access_denied_description": "Contactați administratorii pentru mai multe informații",
  "access_denied_logout_btn": "Deconectare",
  "access_denied_operator_label": "Operator",
  "access_denied_title": "Fără acces la resursele magazinului",
  "bet_builder": "Bet Builder",
  "bet_details_header_event": "Eveniment",
  "bet_details_header_market": "Piață",
  "bet_details_header_odds": "Cote",
  "bet_details_header_outcome": "Rezultat",
  "bet_details_header_status": "Status",
  "bet_details_header_time": "Oră",
  "bet_details_payment": "Plată",
  "bet_details_payment_tax": "Taxă pe plată",
  "bet_details_possible_payout": "Plată posibilă",
  "bet_details_possible_winnings": "Câștiguri posibile",
  "bet_details_stake": "Miză",
  "bet_details_tax_on_winnings": "Taxă pe câștiguri",
  "bet_type_combo": "Combo",
  "bet_type_multibet": "Multibet",
  "bet_type_single": "Single",
  "bet_type_system": "Sistem",
  "betslip_action_accepted": "Acceptat",
  "betslip_action_failed": "Eșuat",
  "betslip_action_pending": "În așteptare",
  "betslip_action_rejected": "Orejected",
  "betslip_payin": "Plată bilet",
  "betslip_table_action": "Acțiune",
  "betslip_table_amount": "Sumă",
  "betslip_table_game": "Joc",
  "betslip_table_id": "ID",
  "betslip_table_status": "Stare",
  "betslip_table_time": "Oră",
  "cash_register_balance_heading": "SOLD ({currency})",
  "cash_register_end_session_cash_to_leave_in_register": "Numerar de lăsat în casa de marcat",
  "cash_register_end_session_cash_transfer": "Transfer de numerar",
  "cash_register_end_session_confirm": "Închide sesiunea",
  "cash_register_end_session_confirm_modal_back": "Înapoi",
  "cash_register_end_session_confirm_modal_message": "Sigur doriți să închideți sesiunea curentă?",
  "cash_register_end_session_confirm_modal_title": "Avertisment",
  "cash_register_end_session_current_physical_cash_balance": "Soldul fizic actual al numerarului",
  "cash_register_end_session_keep_all_cash_in_register_heading": "Sold ({currency})",
  "cash_register_end_session_keep_all_cash_in_register_option_label": "Păstrează tot numerarul în casa de marcat",
  "cash_register_end_session_keep_all_cash_in_register_title": "SOLD",
  "cash_register_end_session_note": "Notă",
  "cash_register_end_session_register_balance": "Soldul casei de marcat",
  "cash_register_end_session_take_out_amount": "Sumă de retras",
  "cash_register_end_session_title": "Închide sesiunea",
  "cash_register_end_session_transfer_type": "Tip transfer",
  "cash_register_end_session_transfer_type_bank": "Bancă",
  "cash_register_end_session_transfer_type_cash": "Numerar",
  "cash_register_make_transfer_amount_label": "Sumă",
  "cash_register_make_transfer_direction_label": "Direcția transferului",
  "cash_register_make_transfer_direction_take_in": "Depunere",
  "cash_register_make_transfer_direction_take_out": "Retragere (descărcare numerar)",
  "cash_register_make_transfer_note_label": "Notă",
  "cash_register_make_transfer_note_placeholder": "Adaugă o notă...",
  "cash_register_make_transfer_submit_button": "Transferă",
  "cash_register_make_transfer_title": "Efectuează transfer",
  "cash_register_make_transfer_type_label": "Tip transfer",
  "cash_register_no_session_description": "Pornește o sesiune nouă pentru a activa casa de marcat",
  "cash_register_no_session_title": "Nu există nicio sesiune activă",
  "cash_register_session_details_balance": "Sold",
  "cash_register_session_details_closed_at": "Închis la",
  "cash_register_session_details_closed_by": "Închis de",
  "cash_register_session_details_duration": "Durată",
  "cash_register_session_details_end_session_button": "Închide sesiunea",
  "cash_register_session_details_id": "ID sesiune",
  "cash_register_session_details_info_title": "Informații sesiune",
  "cash_register_session_details_make_transfer_button": "Efectuează transfer",
  "cash_register_session_details_opened_at": "Deschis la",
  "cash_register_session_details_opened_by": "Deschis de",
  "cash_register_session_details_operators": "Operatori",
  "cash_register_session_details_opt_in_button": "Alătură-te",
  "cash_register_session_details_opted_in_button": "Alăturat",
  "cash_register_session_details_title": "Sesiuni",
  "cash_register_session_details_transactions": "Tranzacții",
  "cash_register_session_details_transactions_credit_debit_card_balance": "Sold card credit/debit ({currency})",
  "cash_register_session_details_transactions_direct_deposits": "Depozite directe",
  "cash_register_session_details_transactions_physical_cash": "Numerar fizic ({currency})",
  "cash_register_session_details_transactions_retail_location_withdrawals": "Retrageri la locația retail",
  "cash_register_session_details_transactions_starting_cash_balance_cash_float": "Sold inițial de numerar (cash float)",
  "cash_register_session_details_transactions_title": "Tranzacțiile sesiunii",
  "cash_register_session_details_transactions_total_balance": "Sold total ({currency})",
  "cash_register_session_details_transactions_voucher_issued": "Emis",
  "cash_register_session_details_transactions_voucher_redeemed": "Răscumpărat",
  "cash_register_session_details_transactions_voucher_revoked": "Revocat",
  "cash_register_session_operators_popup_description": "Lista operatorilor incluși în această sesiune",
  "cash_register_session_opt_in_failed": "Alăturarea la sesiune a eșuat!",
  "cash_register_start_session_failed": "Pornirea sesiunii a eșuat!",
  "cash_register_start_session_info_notification": "Soldul inițial de numerar este determinat de sesiunea închisă anterior. Poți corecta oricând soldul de numerar folosind acțiunea „Efectuează transfer”.",
  "cash_register_start_session_success": "Sesiune nouă pornită!",
  "cash_register_start_session_title": "Pornește sesiunea",
  "cash_register_starting_cash_balance": "Sold inițial de numerar",
  "common_all_info": "Toate informațiile",
  "common_app_version": "Versiunea aplicației",
  "common_back": "Înapoi la",
  "common_betshop": "Agenție de pariuri",
  "common_cancel": "Anulează",
  "common_company": "Companie",
  "common_copy_all_info": "Copiază toate informațiile",
  "common_currency": "Monedă",
  "common_deposits": "Depozite",
  "common_device": "Dispozitiv",
  "common_device_uuid": "UUID dispozitiv",
  "common_direct_transfer": "Transfer direct",
  "common_error": "A apărut o eroare necunoscută. Vă rugăm să încercați din nou",
  "common_games": "Jocuri",
  "common_info": "Informații",
  "common_language": "Limbă",
  "common_load_more": "Încarcă mai mult",
  "common_logout": "Deconectare",
  "common_menu": "Meniu",
  "common_operations": "Operațiuni",
  "common_payin": "Încasare",
  "common_payout": "Plată",
  "common_plugins": "Pluginuri",
  "common_print": "Tipărire",
  "common_products": "Produse",
  "common_rebet": "Rebet",
  "common_save": "Salvează",
  "common_services": "Servicii",
  "common_settings": "Setări",
  "common_start_session": "Pornește sesiunea",
  "common_transfers": "Transferuri",
  "common_unknown": "Necunoscut",
  "common_voucher": "Voucher",
  "common_vouchers": "Vouchere",
  "deposits_direct_deposit_create_error": "Crearea depunerii a eșuat!",
  "deposits_direct_deposit_create_success": "{amount}{currency} depus la jucătorul \"{playerNickname}\"",
  "deposits_direct_deposit_form_max_amount_validation_error": "Suma maximă este {amount}",
  "deposits_direct_deposit_form_min_amount_validation_error": "Suma minimă este {amount}",
  "deposits_direct_deposit_form_player_label": "E-mail sau pseudonim jucător",
  "deposits_direct_deposit_form_player_not_found": "Jucătorul nu a fost găsit",
  "deposits_direct_deposit_form_submit_button": "Următorul",
  "deposits_direct_deposit_method_card": "Card",
  "deposits_direct_deposit_method_cash": "Numerar",
  "deposits_direct_deposit_player_side_sheet_email": "E-mail",
  "deposits_direct_deposit_player_side_sheet_full_name": "Nume complet",
  "deposits_direct_deposit_player_side_sheet_nickname": "Pseudonim",
  "deposits_direct_deposit_player_side_sheet_verification_status": "Status verificare",
  "deposits_direct_deposit_print_failed": "Confirmarea nu a putut fi tipărită din cauza unei erori la imprimantă.",
  "deposits_direct_deposit_side_sheet_amount_label": "Sumă depunere",
  "deposits_direct_deposit_side_sheet_confirm_button": "Confirmă depunerea",
  "deposits_direct_deposit_side_sheet_method_label": "Metodă depunere",
  "deposits_direct_deposit_side_sheet_title": "Depunere directă",
  "deposits_direct_deposit_verification_status_fully_verified": "Complet verificat",
  "deposits_direct_deposit_verification_status_not_verified": "Neverificat",
  "deposits_direct_deposit_verification_status_partially_verified": "Parțial verificat",
  "deposits_direct_deposits_no_session_notification": "Pentru a efectua o depunere trebuie să porniți sesiunea.",
  "deposits_direct_table_empty_description": "Nu există depuneri în ultimele {timePeriod}.",
  "deposits_direct_table_empty_title": "Nicio depunere",
  "deposits_direct_table_header_amount": "Sumă",
  "deposits_direct_table_header_id": "ID depozit",
  "deposits_direct_table_header_made_at": "Creat",
  "deposits_direct_table_time_period_label": "Perioadă de timp",
  "deposits_direct_table_title": "Ultimele depuneri",
  "deposits_direct_transfer_subtitle": "Creați o depunere și creditați fonduri direct în contul unui jucător. Depunerile efectuate de dvs. sunt listate mai jos.",
  "deposits_direct_transfer_title": "Efectuează depunere directă",
  "deposits_voucher_create_error": "Crearea voucherului a eșuat!",
  "deposits_voucher_create_success": "Voucher creat.",
  "deposits_voucher_form_amount_label": "Sumă",
  "deposits_voucher_form_create_button": "Crează",
  "deposits_voucher_form_max_amount_validation_error": "Suma maximă este {amount}",
  "deposits_voucher_form_min_amount_validation_error": "Suma minimă este {amount}",
  "deposits_vouchers_subtitle": "Creați un voucher pe care jucătorii îl pot folosi ca metodă de plată. Voucherele create de dvs. sunt listate mai jos.",
  "deposits_vouchers_table_empty_description": "Nu există vouchere create în ultimele {timePeriod}.",
  "deposits_vouchers_table_empty_title": "Niciun voucher",
  "deposits_vouchers_table_header_created": "Creat",
  "deposits_vouchers_table_header_source": "Sursă",
  "deposits_vouchers_table_header_status": "Status",
  "deposits_vouchers_table_header_value": "Valoare",
  "deposits_vouchers_table_header_voucher_id": "ID voucher",
  "deposits_vouchers_table_time_period_label": "Perioadă de timp",
  "deposits_vouchers_title": "Creare voucher",
  "info_tab_main_info": "Informații principale",
  "info_tab_working_time": "Timp de lucru",
  "info_working_time_open": "Deschis",
  "info_working_time_closed": "Închis",
  "info_copy_to_clipboard_success": "{ title } copiat în clipboard.",
  "keyboard_shortcuts_not_found": "Nu există prețări active pentru această categorie!",
  "login_operator_account_disabled_error_message": "Acces refuzat. Contul este momentan dezactivat.",
  "login_operator_credentials_error_message": "Date de autentificare ale operatorului invalide",
  "login_operator_device_not_connected_error_message": "Acces refuzat. Dispozitivul nu este conectat.",
  "login_operator_max_concurrent_sessions_error_message": "Acces refuzat. Ați atins numărul maxim de sesiuni simultane pe dispozitive. Deconectați-vă de pe alt dispozitiv și încercați din nou.",
  "login_operator_default_button_text": "Autentificare",
  "login_operator_pass_label": "Parolă",
  "login_operator_remember_username": "Reține numele de utilizator",
  "login_operator_title": "Autentificare operator",
  "login_operator_unauthorized_location_error_message": "Acces refuzat. Nu sunteți autorizat să vă autentificați din această locație.",
  "login_operator_user_label": "Nume utilizator",
  "operator_logout": "Ați fost deconectat.",
  "operation_navigation_cash_register": "Casa de marcat",
  "operation_navigation_deposits": "Depozite",
  "operation_navigation_keyboard_shortcuts": "Prețări",
  "operation_navigation_reports": "Rapoarte",
  "operation_navigation_settings": "Setări",
  "operation_navigation_withdrawal": "Plăți",
  "printer_action_perform_print_failed": "Acțiunea imprimantei a eșuat. Vă rugăm să încercați din nou.",
  "printer_action_perform_print_success": "Tipărit cu succes",
  "printer_action_refresh_success": "Lista imprimantelor PoS a fost reîmprospătată",
  "printer_autocutter": "Tăietor automat",
  "printer_cover_open": "Capacul imprimantei este deschis",
  "printer_offline": "Imprimanta este offline, verificați hârtia și capacul imprimantei",
  "printer_paper_error_notification": "Nu mai există hârtie în imprimantă. Vă rugăm să contactați operatorul.",
  "printer_paper_low": "Hârtie insuficientă",
  "printer_paper_out": "Fără hârtie",
  "printer_paper_out_while_printing": "Fără hârtie în timpul tipăririi",
  "settings_interface_language": "Limba interfeței",
  "settings_last_tickets": "Ultimele bilete",
  "settings_last_tickets_current_game": "Jocul curent",
  "settings_last_tickets_games": "Afișează biletele din jocuri",
  "settings_last_tickets_games_placeholder": "Selectați jocuri",
  "settings_last_tickets_number": "Numărul de bilete de afișat",
  "settings_last_tickets_number_placeholder": "Selectați cantitatea",
  "settings_last_tickets_show_all": "Afișează toate",
  "settings_modal_discard_changes": "Renunță",
  "settings_modal_unsaved_changes_message": "Aveți modificări nesalvate. Dacă părăsiți această filă, le veți pierde?",
  "settings_modal_unsaved_changes_title": "Avertisment",
  "settings_print_a4_configuration": "Configurație imprimantă A4",
  "settings_print_a4_configuration_description": "Format hârtie A4",
  "settings_print_a4_test": "Test tipărire pentru imprimanta A4",
  "settings_print_a4__test_modal_title": "Test tipărire",
  "settings_print_a4_title": "Imprimantă A4",
  "settings_print_configure": "Configurează",
  "settings_print_pos_configuration": "Configurație imprimantă PoS",
  "settings_print_pos_configuration_description": "Configurația aspectului tipăririi",
  "settings_print_pos_configuration_label": "Selectați configurația",
  "settings_print_pos_printer": "Imprimantă PoS",
  "settings_print_pos_printer_label": "Selectați imprimanta PoS",
  "settings_print_pos_test": "Test tipărire pentru imprimanta PoS",
  "settings_print_pos_title": "Imprimantă PoS",
  "settings_print_test": "Test tipărire",
  "settings_printing_language": "Limba de tipărire",
  "settings_save_success": "Modificările au fost salvate",
  "slip_action_check": "Verifică",
  "slip_action_print_copy": "Tipărește copie",
  "slip_action_rebet": "Ponovire",
  "slip_cancel_ticket": "Anulează biletul",
  "slip_cancel_ticket_failed": "Anularea biletului a eșuat",
  "slip_check_details_bet_title": "Pariu {index}: {title}",
  "slip_check_details_betslip_id": "ID bilet",
  "slip_check_error": "Eroare la verificarea biletului.",
  "slip_check_modal_check_button": "Verifică",
  "slip_check_modal_content": "Introduceți ID-ul tichetului sau scanați codul de bare pentru a vedea detaliile tichetului.",
  "slip_check_modal_ticket_id_label": "ID tichet",
  "slip_check_modal_title": "Verificare tichet",
  "slip_payin": "Plată bilet",
  "slip_payin_success": "Biletul a fost plătit cu succes.",
  "slip_payout_betslip": "Plată bilet: {amount} {currency}",
  "slip_payout_failed": "Plată a eșuat",
  "slip_pending_action": "Vă rugăm să așteptați confirmarea biletului.",
  "slip_print_copy": "Tipărește copie",
  "slip_print_copy_failed": "Tipărirea copiei a eșuat",
  "slip_print_failed": "Tipărirea biletului a eșuat",
  "slip_print_payout_confirmation": "Tipărește confirmarea plății",
  "slip_print_payout_confirmation_failed": "Tipărirea confirmării plății a eșuat",
  "slip_rebet_failed": "Rebet a eșuat",
  "slip_resolve_failed": "Anularea biletului a eșuat",
  "slip_status_accepted": "Acceptat",
  "slip_status_failed": "Eșuat",
  "slip_status_pending": "În așteptare",
  "slip_status_rejected": "Orejected",
  "slip_table_action": "Acțiune",
  "slip_table_amount": "Sumă",
  "slip_table_game": "Joc",
  "slip_table_id": "ID",
  "slip_table_status": "Stare",
  "slip_table_time": "Oră",
  "time_period_last_24_hours": "Ultimele 24 de ore",
  "time_period_last_hour": "Ultima oră",
  "voucher_details_footer_redeem": "Răscumpără voucher",
  "voucher_details_footer_revoke": "Revocă voucher",
  "voucher_details_header_amount": "Sumă",
  "voucher_details_header_issued_in": "Emis în",
  "voucher_details_header_redeemed_at": "Răscumpărat la",
  "voucher_details_header_redeemed_in": "Răscumpărat în",
  "voucher_details_header_status_expired": "Expirat",
  "voucher_details_header_status_redeemed": "Răscumpărat",
  "voucher_details_header_status_revoked": "Revocat",
  "voucher_details_header_status_valid": "Valabil: {date}",
  "voucher_details_header_valid_until": "Valabil până la",
  "voucher_print_failed": "Trimiterea voucherului la tipărit a eșuat.",
  "voucher_print_success": "Voucherul a fost tipărit cu succes.",
  "voucher_redeem_failed": "Răscumpărarea voucherului a eșuat.",
  "voucher_revoke_failed": "Revocarea voucherului a eșuat.",
  "voucher_revoke_success": "Voucherul a fost revocat cu succes.",
  "widget_latest_betslips": "Ultimele bilete",
  "widget_shortcuts_title": "Prețări",
  "widget_shortcuts_all_shortcuts": "Toate prețările",
  "widget_calculator": "Calculator",
  "calculator_transactions_title": "Tranzacții",
  "calculator_session_tab": "Sesiune {currency}",
  "calculator_table_title": "Tabel ({count})",
  "calculator_no_transactions": "Nu există tranzacții înregistrate în sesiunea curentă a calculatorului.",
  "calculator_money_in": "Bani primiți",
  "calculator_money_in_modal_title": "Bani primiți",
  "calculator_payments": "Plăți",
  "calculator_payouts": "Câștiguri plătite",
  "calculator_rest": "Rest",
  "calculator_give_to_player": "De dat jucătorului",
  "calculator_collect_from_player": "De încasat de la jucător",
  "calculator_reset_session": "Resetează sesiunea",
  "calculator_clear_session_currency": "Șterge {currency}",
  "calculator_pin_view": "Fixează calculatorul",
  "calculator_full_screen": "Vizualizare extinsă",
  "calculator_helper_tip": "Când înmânați numerar jucătorului, goliți calculatorul sau excludeți tranzacția din jurnal pentru a evita greșelile.",
  "calculator_reset_session_title": "Resetează sesiunea",
  "calculator_reset_session_message": "Sigur doriți să resetați sesiunea curentă?",
  "calculator_reset_session_confirm": "Resetează",
  "calculator_close": "Închide",
  "calculator_excluded_transactions_warning": "Ați exclus manual {excluded}/{total} tranzacții",
  "calculator_table_include": "Include",
  "calculator_table_item": "Element",
  "calculator_table_id": "ID",
  "calculator_table_time": "Ora",
  "calculator_table_action": "Acțiune",
  "calculator_table_amount": "Sumă (+/-)",
  "calculator_table_status": "Status",
  "calculator_action_betslip_payin": "Plată bilet",
  "calculator_action_betslip_payout": "Plată câștig",
  "calculator_action_betslip_cancel": "Anulare bilet",
  "calculator_action_betslip_cashout": "Cashout bilet",
  "calculator_action_voucher_create": "Creare voucher",
  "calculator_action_voucher_redeem": "Valorificare voucher",
  "calculator_status_pending": "În așteptare",
  "calculator_status_success": "Succes",
  "calculator_status_fail": "Eșuat",
  "calculator_status_reject": "Respins",
  "working_hours_off": "Location working hours are currently off. Next opening: {datetime}."
}
